export const normalizeStatus = (s) => {
  if (!s) return s;
  const val = String(s).trim().toLowerCase();
  if (val === 'fail') return 'Failed';
  if (val === 'pass') return 'Success';
  return s;
};

export const normalizeReqType = (type) => {
  if (!type) return type;
  const val = String(type).trim().toUpperCase();
  switch (val) {
    case 'N':  return 'New Configuration';
    case 'MC': return 'Meter Change';
    case 'RU': return 'Refranchise Units';
    case 'RF': return 'Refranchise Fleet';
    default:   return type;
  }
};
